import { render, staticRenderFns } from "./c-modal.vue?vue&type=template&id=5d2aa274&scoped=true"
import script from "./c-modal.vue?vue&type=script&lang=js"
export * from "./c-modal.vue?vue&type=script&lang=js"
import style0 from "./c-modal.vue?vue&type=style&index=0&id=5d2aa274&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2aa274",
  null
  
)

export default component.exports